import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiPrinter
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonPrint: React.FC <ButtonCreateInterface> = ({
  text,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = "sm",
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Print data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "success"}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            <HiPrinter className="mb-1" />
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Print'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}